import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { AudioFileClient } from '../../api/server';
import { Button, MenuItem, Select } from '@mui/material';
import { ExtendedClient } from '../../api/ExtendedClient';

function MusicOnHold() {
    let { currentPhoneNumberId } = useParams();
    const navigate = useNavigate();

    const [audioFiles, setAudioFiles] = useState([]);

    const [audioFile1, setAudioFile1] = useState("0");
    const [audioFile2, setAudioFile2] = useState("0");
    const [audioFile3, setAudioFile3] = useState("0");
    const [audioFile4, setAudioFile4] = useState("0");
    const [audioFile5, setAudioFile5] = useState("0");

    const globalInfo = useSelector((state) => state.globalInfo)


  


    const onClose = () => {
        navigate('/phonenumbers')
    }

    function save() {
        navigate('/phonenumbers')
    }

    useEffect(() => {
        function refresh() {
            const client = (new ExtendedClient(AudioFileClient)).getClient();
       
            client.getAudioFiles(globalInfo.currentCompanyId).then((data) => {
                setAudioFiles(data)
    
            })
        }

        refresh();
        
    }, [globalInfo, currentPhoneNumberId])



    return (
        <div>
            <h1>
                On Hold Marketing Messages <br></br>
            </h1>


            {audioFiles && audioFiles.length > 0 &&

                <div>
                    <div>
                        {
                            <div>
                                Marketing Audio {1}  : &nbsp;
                                <Select style={{ width: 370 }} onChange={(val) => { setAudioFile1(val.target.value) }} value={audioFile1}>
                                    <MenuItem value={"0"}>{"Default Music"}</MenuItem>
                                    {
                                        audioFiles.map((item, index) => {
                                            return <MenuItem value={item.audioFileId} key={index} >{item.name}</MenuItem>
                                        })
                                    }
                                </Select>
                                <br></br><br></br>
                            </div>
                        }
                    </div>

                    <div>
                        {
                            <div>
                                Marketing Audio {2}  : &nbsp;
                                <Select style={{ width: 370 }} onChange={(val) => { setAudioFile2(val.target.value) }} value={audioFile2}>
                                    <MenuItem value={"0"}>{"Default Music"}</MenuItem>
                                    {
                                        audioFiles.map((item, index) => {
                                            return <MenuItem value={item.audioFileId} key={index} >{item.name}</MenuItem>
                                        })
                                    }
                                </Select>
                                <br></br><br></br>
                            </div>
                        }
                    </div>

                    <div>
                        {
                            <div>
                                Marketing Audio 3  : &nbsp;
                                <Select style={{ width: 370 }} onChange={(val) => { setAudioFile3(val.target.value) }} value={audioFile3}>
                                    <MenuItem value={"0"}>{"Default Music"}</MenuItem>
                                    {
                                        audioFiles.map((item, index) => {
                                            return <MenuItem value={item.audioFileId} key={index} >{item.name}</MenuItem>
                                        })
                                    }
                                </Select>
                                <br></br><br></br>
                            </div>
                        }
                    </div>
                    <div>
                        {
                            <div>
                                Marketing Audio 4  : &nbsp;
                                <Select style={{ width: 370 }} onChange={(val) => { setAudioFile4(val.target.value) }} value={audioFile4}>
                                    <MenuItem value={"0"}>{"Default Music"}</MenuItem>
                                    {
                                        audioFiles.map((item, index) => {
                                            return <MenuItem value={item.audioFileId} key={index} >{item.name}</MenuItem>
                                        })
                                    }
                                </Select>
                                <br></br><br></br>
                            </div>
                        }
                    </div>
                    <div>
                        {
                            <div>
                                Marketing Audio 5  : &nbsp;
                                <Select style={{ width: 370 }} onChange={(val) => { setAudioFile5(val.target.value) }} value={audioFile5}>
                                    <MenuItem value={"0"}>{"Default Music"}</MenuItem>
                                    {
                                        audioFiles.map((item, index) => {
                                            return <MenuItem value={item.audioFileId} key={index} >{item.name}</MenuItem>
                                        })
                                    }
                                </Select>
                                <br></br><br></br>
                            </div>
                        }
                    </div>
                </div>

            }

            <Button variant='outlined' onClick={() => { save() }}>Save</Button> &nbsp;&nbsp;
            <Button variant="outlined" onClick={() => { onClose() }}>Close</Button>
        </div>

    )
}

export default MusicOnHold